module.exports = __webpack_public_path__ + "img/heart-fill-red.fbbe4bed.svg";